module.exports = __webpack_public_path__ + "img/done.dfb8d757.png";